import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import colors from "assets/theme/base/colors";

function MDTimePicker({ label, value, onChange, onBlur, name, required, padding, width }) {
  const [open, setOpen] = useState(false);
  const { datePicker } = colors;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        name={name}
        label={
          <span>
            {label} {required && <span style={{ color: "red" }}>*</span>}
          </span>
        }
        sx={{
          width: width ?? "100%",
          "& fieldset": {
            border: "0",
            borderBottom: "1px solid",
            borderRadius: "0",
          },
          "& .MuiFormLabel-root": {
            color: `${datePicker.color}`,
            position: "absolute",
            left: "-14px",
          },
          "& .MuiInputBase-input": {
            padding: padding ? `${padding} !important` : undefined,
            paddingLeft: !padding ? "0px !important" : undefined,
          },
        }}
        onChange={(time) => {
          if (time) {
            const formattedTime = dayjs(time).format("HH:mm:ss");
            onChange(formattedTime);
          } else {
            onChange(null);
          }
        }}
        value={dayjs(value, "HH:mm:ss")}
        onBlur={onBlur}
        format="hh:mm A"
        // open={open}
        className="datePicker__Input"
        onClose={() => setOpen(false)}
        slotProps={{
          actionBar: {
            actions: ["clear", "accept"],
          },
          textField: {
            onClick: () => setOpen(true),
          },
        }}
      />
    </LocalizationProvider>
  );
}

MDTimePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  required: PropTypes.bool,
};

export default MDTimePicker;
